import './less/popup.less';

const popupGeneric = () => {
	let popup = document.getElementById('JS_mass-popup');
	
	if(popup) {
		let close = document.getElementById('JS_mass-popup__close');
		
		popup.classList.remove('hidden');
		
		if(close) {
			close.addEventListener('click', e => {
				e.preventDefault();
				
				if(e.currentTarget.href && e.currentTarget.href !== '') {
					popup.classList.add('hidden');
					
					window.location.href = e.currentTarget.href;
				}
			});
		}
		
	}
};

export default popupGeneric();


// WEBPACK FOOTER //
// ./components/popup/popupGeneric.js